import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import AfterSchoolProgramsDetails from '../../subdepartmentdetails/AfterSchoolPrograms'


function AfterSchoolPrograms() {

  useEffect(() => {
    document.getElementById("title").innerHTML="After-School and Summer Programs || Education";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Education Youth Services"
            title="After School Programs"
            subtitledown="Department of Education"
           />
            <AfterSchoolProgramsDetails/>
        </div>
    </>
  )
}

export default AfterSchoolPrograms